import { Button, ButtonProps, Popover, Theme } from '@mui/material';
import * as React from 'react';
import { ReactNode, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  popover: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

type ButtonWithPopoverProps = Partial<ButtonProps> & {
  label: string;
  children: ReactNode;
  endIcon?: ReactNode;
  fullWidth?: boolean;
  color?: 'primary' | 'secondary' | 'default';
  style?: React.CSSProperties;
  size?: 'small' | 'medium' | 'large';
  rest?: Partial<ButtonProps>;
};

const ButtonWithPopover = ({
  label,
  children,
  endIcon,
  style,
  fullWidth,
  color = 'primary',
  size = 'medium',
  ...rest
}: ButtonWithPopoverProps) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);

  const id = popoverOpen ? 'simple-popover' : undefined;

  const togglePopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setPopoverOpen(!popoverOpen);
  };

  return (
    <>
      <Button
        style={style}
        variant="outlined"
        color={color}
        onClick={togglePopover}
        endIcon={endIcon}
        fullWidth={fullWidth}
        size={size}
        {...rest}
      >
        {label}
      </Button>

      <Popover
        id={id}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => setPopoverOpen(false)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{ paper: classes.popover }}
      >
        {children}
      </Popover>
    </>
  );
};

export default ButtonWithPopover;
